import WrapperLayout from 'components/Layout';
import Main from './components/Main';
const CertificateSearch = () => {
    return (
        <WrapperLayout>
            <Main />
        </WrapperLayout>
    )
}
export default CertificateSearch